module.exports = __webpack_public_path__ + "static/media/Hoehle_Teaser.0e96f5ea.jpg";